//let baseURL = process.env.NODE_ENV === "development" ? process.env.REACT_APP_BASE_URL_DEV : process.env.REACT_APP_BASE_URL_LIVE;

//For Local

// let baseURL = "http://192.168.10.62:4004/";



//For QA
// let baseURL = "https://api.zindagihealthcare.com/";

//For UAT
// let baseURL = "https://api.zindagihealthcare.com/";

//For Prod
let baseURL = "https://api.zindagihealthcare.com/";
// let baseURL = "http://localhost:4004/";


export { baseURL };
